import Swiper from "swiper";
import { Navigation } from "swiper/modules";

class ProductSlider {
  constructor() {
    this.sliderInit();
  }

  sliderInit = () => {
    const slider = new Swiper(".js-product-slider", {
      modules: [Navigation],
      spaceBetween: 32,
      slidesPerView: "auto",
      loop: true,
      grabCursor: true,
      navigation: {
        nextEl: ".js-product-slider-next",
        prevEl: ".js-product-slider-prev",
      },
    });
  };
}
export default ProductSlider;

new ProductSlider();
